var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwapSwapArrowHorizontal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#717680",
    d: "M29.513 5.327A1.667 1.667 0 0 0 26.86 6.79l.275 3.705c.029.39.052.781.069 1.172H11.667a1.667 1.667 0 1 0 0 3.333h15.537c-.017.39-.04.781-.07 1.171l-.274 3.706a1.667 1.667 0 0 0 2.653 1.463 35.255 35.255 0 0 0 6.555-6.304 2.72 2.72 0 0 0 0-3.405 35.257 35.257 0 0 0-6.555-6.304ZM13.14 20.123a1.667 1.667 0 0 0-2.653-1.463 35.255 35.255 0 0 0-6.555 6.304 2.72 2.72 0 0 0 0 3.405 35.258 35.258 0 0 0 6.555 6.304 1.667 1.667 0 0 0 2.653-1.463l-.275-3.706a38.19 38.19 0 0 1-.069-1.17h15.537a1.667 1.667 0 1 0 0-3.334H12.796c.017-.39.04-.781.07-1.171l.274-3.706Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapSwapArrowHorizontal);
export default __webpack_public_path__ + "static/media/swap_swap-arrow-horizontal.04a5ea722dde9ff1a3fd202380072d9e.svg";
export { ForwardRef as ReactComponent };